import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux'
import {useLocation, useNavigate} from "react-router-dom";
import logo from '../../assets/site-logo.png';
import * as Routes from "../../utils/routes";
import {getAuth, OAuthProvider, signInWithPopup} from "firebase/auth";
import * as userActions from '../../redux/User/actions';
import LoadingPanel from "../../components/LoadingPanel";
import errorImage from '../../assets/errorpage-image.png';
import FloatingImage from "../../components/FloatingImage";

import './ErrorPage.scss';

const ErrorPage = props => {
	return (
		<div className="error-wrapper">
			<div className="error-container">

				<img src={errorImage} alt="" />

				<div className="error-title">Whoops!</div>

				<div className="error-description">
					Something went wrong. It might be our fault.
					Email us at <a href="mailto:support@connact.cloud"><b>support@connact.cloud</b></a>, we’ll get back to you as soon as possible.
				</div>
			</div>
		</div>
	)
};

export default ErrorPage;
